export async function getItemsByCategory(categorySlug: string) {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_ENDPOINT}/api/items?filters[category][slug]=${categorySlug}&populate[size][populate]=numberFilter&populate[size][populate]=selectFilter&populate[image]=*`,
    );
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = (await response.json()) as { data: Array<{ attributes: any }> };
    return data.data;
  } catch (error) {
    console.error('Error fetching items by category:', error);
    return [];
  }
}

export async function getItemBySize(sizeId: string) {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_ENDPOINT}/api/items?populate[size][populate]=numberFilter&populate[size][populate]=selectFilter&populate[image]=*`,
    );
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = (await response.json()) as { data: Array<{ id: number; attributes: any }> };

    const item = data.data.find((item) =>
      item.attributes.size.some((size: { id: number }) => size.id.toString() === sizeId.replace(/^0+/, '')),
    );

    if (!item) throw new Error(`Item with size id ${sizeId} not found`);

    const filteredItem = {
      ...item,
      attributes: {
        ...item.attributes,
        size: item.attributes.size.filter((size: { id: number }) => size.id.toString() === sizeId.replace(/^0+/, '')),
      },
    };

    return filteredItem;
  } catch (error) {
    console.error('Error fetching item with specific size:', error);
    throw error;
  }
}
